import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import supabase from '../../../../supabaseClient';
import { useAuth } from '../../../../contexts/authContext';
import { usePermissions } from '../../../../contexts/PermissionsContext';

const TeacherLMSLayout = () => {
  const [pendingEvaluations, setPendingEvaluations] = useState(0);
  const [newForumPosts, setNewForumPosts] = useState(0);
  const { user } = useAuth();
  const { hasPermission } = usePermissions();

  useEffect(() => {
    const userId = user?.id;
    if (userId) {
      supabase.rpc('count_pending_evaluations_for_teacher')
        .then(({ data, error }) => {
          if (error) {
            console.error('Error fetching pending evaluations:', error);
            setPendingEvaluations(0);
          } else {
            setPendingEvaluations(data || 0);
          }
        });
      supabase.rpc('count_new_forum_posts', { user_id: userId })
        .then(({ data }) => setNewForumPosts(data || 0));
    }
  }, [user]);

  return (
    <div className="lms-layout">
      <main className="lms-main-content" tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
};

export default TeacherLMSLayout;
